/**
 *  @class
 *  @function SpecDrawerLinks
 *  Accordion-style trigger rows that open their own spec side drawer instead
 *  of expanding. Each <summary data-spec-target="drawer-id"> opens that drawer.
 *
 *  The section renders its drawers inside <main>. drawer-a11y.js inerts every
 *  sibling on the open drawer's ancestor chain — which, for a drawer nested in
 *  <main>, includes the global .click-capture overlay, killing click-outside.
 *  So we relocate each drawer up to #wrapper (where the theme's cart/product
 *  drawers live) so only <main> is inerted and the overlay stays clickable.
 *
 *  Closing + focus trap are handled globally by side-panel-close, the
 *  .click-capture overlay (click outside), and drawer-a11y.js.
 */
if (!customElements.get('spec-drawer-links')) {
  class SpecDrawerLinks extends HTMLElement {
    connectedCallback() {
      const host = document.getElementById('wrapper') || document.body;

      this.querySelectorAll('summary[data-spec-target]').forEach((summary) => {
        const targetId = summary.getAttribute('data-spec-target');
        const drawer = document.getElementById(targetId);
        if (drawer && drawer.parentElement !== host) {
          host.appendChild(drawer);
        }

        const openDrawer = (event) => {
          // Stop the <details> from toggling — this row is a drawer trigger.
          event.preventDefault();
          const target = document.getElementById(targetId);
          if (!target) return;
          document.body.classList.add('open-cc');
          target.classList.add('active');
        };

        summary.addEventListener('click', openDrawer);
        summary.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ' || event.code === 'Space') {
            openDrawer(event);
          }
        });
      });
    }
  }

  customElements.define('spec-drawer-links', SpecDrawerLinks);
}
